import React, { Component } from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import {connect} from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Alert from 'react-s-alert';
import { sendLog } from '../../util'

//Se accede a firebase
const database = firebase.database();

//Estilo para los modales 
const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      transform             : 'translate(-50%, -50%)',
      width                 : '450px'
      
    }
  };


class Modal_Costos extends Component{
    constructor(){
        super();
        this.state={
            isActive:false,
            codigo:'',
            descripcion:'',
            responsable:'',
            area:'',
            empresaUID:'',
            avaliable:false
        };
        //Se realiza bind para que las funciones no den error a la ejecucion
        this.handleSubmit=this.handleSubmit.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);

        //Se obtiene los datos de los nodos
        this.costosRef=database.ref().child('CentroCosto');
    }

    componentWillMount(){
        let uid = this.props.EmpresaUID;
        this.setState({empresaUID:uid})
    }

    //manejo del post del form
    handleSubmit=(event)=>{

        let estado = '';
        if (this.state.avaliable) {
            estado = 'Operativo';
        }
        else{
            estado = this.state.avaliable;
        }
        //Se verifica si hay algun registro que tenga un codigo igual
        this.costosRef.orderByChild('codigo').equalTo(this.Codigo.value).once("value").then(snapshot=>{
    
            if(snapshot.exists()){
					
                Alert.warning('Ya hay un centro de costo con este codigo', {
                    effect: 'genie',
                    position: 'bottom-right',
                    timeout:2000			
                });
                
            }
            else{ 
                const idKey = this.costosRef.push({
                
                        codigo:this.Codigo.value,
                        descripcion:this.Descripcion.value,
                        responsable:this.Responsable.value,
                        area:this.Area.value,
                        empresa:this.state.empresaUID,
                        estado
                }).key	
        
                            
                this.toggleModal();
                sendLog({ tipo: 'centro_costos_nuevo', informacion_extra: {centro_costo: idKey} });
                Alert.success('Datos guardados correctamente', {
                    effect: 'genie',
                    position: 'bottom-right',
                    timeout:2000			
                });
            }
        });
        event.preventDefault();
    }

    //Manejo de Estado de la apertura del modal 

    toggleModal=()=>{
		
		this.setState({
			isActive:!this.state.isActive,
			foto:null,
			uploadValue:0
		})
    }
    
    //Validaciones de solo numeros
    handleKeyPressNumeros(e){
	
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	
    }
    
    //Validacion solo letras
    handleKeyPressLetras(e){
		
		let tecla=e.which;
		
		let patron =/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!=32 && tecla!=91 ){			
			e.preventDefault();		
		}	
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    render() {
        let {avaliable} = this.state;
        return (
            <div className="ingreso_costos">
                <button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
                
                <Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
                <h3>Agregar Centro de costos</h3>
                    <hr/>
                    <form method="POST" action="" onSubmit={this.handleSubmit}>
                        
                        <div className="form-row">
                            <div className="form-group col-md-8">
                                <label htmlFor="codigo" >Codigo:</label>
                                <input type="text" className="form-control" name="codigo" 
                                    ref={input => {this.Codigo=input;}}
                                    required autocomplete="off"
                                    placeholder="Codigo"
                                    defaultValue={this.state.Codigo}
                                />
                            </div>
                            <div class="form-group col-md-3" style={{ top: '39px', left: '50px' }}>
                                <input name="avaliable" className="form-check-input" type="checkbox" checked={avaliable} onChange={this.handleInputChange} />
                                <label class="form-check-label" for="avaliable">
                                Operativo
                                </label>
                                <br></br>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="desc">Descripción</label>
                            <input type="text" name="desc" className="form-control"
                            placeholder="Descripción" required autoComplete="off"
                            ref={input => {this.Descripcion=input;}}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="resp">Responsable</label>
                            <input type="text" name="resp" className="form-control"
                            placeholder="Responsable" required autoComplete="off"
                            ref={input => {this.Responsable=input;}}
                            onKeyPress={this.handleKeyPressLetras}
                            />
					    </div>
                        <div className="form-group">
                            <label htmlFor="area">Area</label>
                            <input type="text" name="area" className="form-control"
                            placeholder="Area" required autoComplete="off"
                            ref={input => {this.Area=input;}}
                            onKeyPress={this.handleKeyPressLetras}
                            />
					    </div>
                        <button className="btn btn-primary buttons" type="submit" >Guardar</button>
					    <button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
                    </form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state)=>({
	EmpresaUID:state.nodo_empresa
});

export default connect(mapStateToProps,null)(Modal_Costos);


// WEBPACK FOOTER //
// ./src/Components/Costos/modal_costos.js